
import request from '@/util/server.js'
// 提交企业认证
export function addEnterpriseCertification (data) {
    return request({
      url: '/enterpriseCertification/submit',
      method: 'post',
    data: data,
    })
  }
  
  //获取企业认证
  export function getCheckState () {
    return request({
      url: '/enterpriseCertification/checkState',
      method: 'get',
    })
  }
  


// WEBPACK FOOTER //
// ./src/api/user/enterpriseCertification.js